
const guidRegex = /^(?:\{?(?:[0-9a-fA-F]){8}-(?:[0-9a-fA-F]){4}-(?:[0-9a-fA-F]){4}-(?:[0-9a-fA-F]){4}-(?:[0-9a-fA-F]){12}\}?)$/;


/**
 * Check if input string match guid format. 
 */
export function isGuid(guid: string | null): boolean {
	return !!guid?.length && guidRegex.test(guid);
}